import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id C317FCCF-DCDB-4429-B1A7-850FED29F5B3
 * name format-pilcrow-arrow-left
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-pilcrow-arrow-left.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatPilcrowArrowLeftIcon = createSvgIcon(<><path d="M8,17V14L4,18L8,22V19H20V17M10,10V15H12V4H14V15H16V4H18V2H10A4,4 0 0,0 6,6A4,4 0 0,0 10,10Z" /></>, 'FormatPilcrowArrowLeftIcon');
export default FormatPilcrowArrowLeftIcon